import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import Button from 'flarum/common/components/Button';
import EditEngineVersionModal from './components/EditEngineVersionModal.tsx';
import type Discussion from 'flarum/common/models/Discussion';
import type ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

export default function addEngineVersionControl() {
  extend(DiscussionControls, 'moderationControls', function (items: ItemList<Mithril.Children>, discussion: Discussion) {
    if (discussion.canEditEngineVersion()) {
      items.add(
        'editEngineVersion',
        <Button icon="fas fa-code-branch" onclick={() => app.modal.show(EditEngineVersionModal, { discussion })}>
          {app.translator.trans('laya-engine-version.forum.discussion_controls.edit_engine_version_button')}
        </Button>
      );
    }
  });
}
